<template>
  <div class="threeD-wrap">
    <div class="box-top">
      <div v-for="(item,index) in topData" :key="index" @click="changeType(item)" :value="item.name" class="litle">
        {{item.name}}
      </div>
    </div>

    <div class="float-box">
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-wendu"></i>温度</div>
        <div>
          <label class="num">{{temperature}}</label>℃
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-shidu"></i>湿度</div>
        <div>
          <label class="num">{{humidity}}</label>%RH
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-shuiwei"></i>水位</div>
        <div>
          <label class="num">{{waterLevel}}</label>%
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-O3"></i>O3</div>
        <div>
          <label class="num">{{O3}}</label>%
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-SF6"></i>SF6</div>
        <div>
          <label class="num">{{SF6}}</label>μL/L
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-O2"></i>O2</div>
        <div>
          <label class="num">{{O2}}</label>%
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-kongtiao"></i>空凋</div>
        <div>
          <label class="num">{{AirConditioning}}</label>
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-menjin"></i>门禁</div>
        <div>
          <label class="num">{{entranceGuard}}</label>
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-zaoyin"></i>噪声</div>
        <div>
          <label class="num">{{noise}}</label>dB
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-fengji"></i>风机</div>
        <div>
          <label class="num">{{fan}}</label>
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-shexiangtou"></i>摄像头</div>
        <div>
          <label class="num">{{camera}}</label>
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-yangan"></i>烟感</div>
        <div>
          <label class="num">{{smoke}}</label>
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-hongwai"></i>红外</div>
        <div>
          <label class="num">{{infrared}}</label>
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-qushuqi"></i>驱鼠器</div>
        <div>
          <label class="num">{{ratControlDevice}}</label>
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-baiyechuang"></i>百叶窗</div>
        <div>
          <label class="num">{{shutters}}</label>
        </div>
      </div>
      <div class="float-box-item">
        <div class="top"><i class="iconfont icon-zhaoming"></i>照明</div>
        <div>
          <label class="num">{{lighting}}</label>
        </div>
      </div>
    </div>
    <div class="canvas" @mousewheel="handleScroll" @mousedown="move" ref="canvas">
      <div style="position: relative;
            width: 100%;
            height: 1400px;" :style="{transform: 'scale('+scale+')',top:top+'px',left:left+'px'}">

        <img src="/img/baseNew.png" style="position: absolute;
            left: 0px;
            top: 0px;" />
        <div v-for="(item,index) in list" @mouseenter.stop="enter($event,index,item)" @mouseleave.stop="leave()" :style="{position: 'absolute',top:item.y+'px',left:item.x+'px'}" :key="index" style="cursor: pointer;">
          <div v-show="imgIndex===index" class="showform" :style="{top:+'20px',left:item.width+'px'}">
            <div class="top">{{item.measureName}}</div>
            <div class="centent">
              <div class="row">
                <div class="left">名称</div>
                <div class="right">{{item.measureName}}</div>
              </div>
              <div class="row">
                <div class="left">生产厂商</div>
                <div class="right">{{form.producers}}</div>
              </div>
              <div class="row">
                <div class="left">安装地点</div>
                <div class="right">{{form.installation}}</div>
              </div>
              <div class="row">
                <div class="left">电流</div>
                <div class="right">{{form.ele}}</div>
              </div>
              <div class="row">
                <div class="left">电压</div>
                <div class="right">{{form.voltage}}</div>
              </div>
              <div class="row">
                <div class="left">总功率因数</div>
                <div class="right">{{form.power}}</div>
              </div>
              <div class="row">
                <div class="left">总功率因数</div>
                <div class="right">{{form.power}}</div>
              </div>
              <div class="row">
                <div class="left">温度</div>
                <div class="right">{{form.temperature}}</div>
              </div>
              <div class="row">
                <div class="left">状态</div>
                <div class="right">{{form.state}}</div>
              </div>
            </div>
          </div>
          <img :src="imgIndex===index?item.enterImg:item.img" @click="getDig(item)" :style="{width:item.width+'px',height:item.height+'px'}" alt />
        </div>
      </div>
    </div>
    <!-- 计量点弹窗 -->
    <el-dialog :title="wintitle" :visible.sync="winalarm" width="1600px" height="800px" style="z-index:9999 !important;height:800px" :close-on-click-modal="false" :destroy-on-close="true">
      <realtimgData v-if="winalarm" :TomeasureId="TomeasureId"></realtimgData>
    </el-dialog>
  </div>
</template>
<script>
let vm;
import api from "@common/api/index.js";
import * as configData from "@/config/index.js";
import realtimgData from "@/components/common/realTimeData/RealtimgData.vue";
import { isNull } from "util";
import { isUndefined } from "util";
export default {
  name: "threeD",
  // 引用组件
  components: {
    realtimgData
  },
  data () {
    return {
      list: '',
      imgIndex: null,
      scale: 1,
      top: 0,
      left: 0,
      selectedGroupId: 0,
      TomeasureId: "1000000001",
      winalarm: false,
      // seen:false,
      wintitle: "详细信息",
      seenPositon: {
        x: '',
        y: ''
      },
      //初始化组件组数据  高压配电房
      //    G01高压柜
      //    G02高压柜
      defaultStore: [{
        displayName: '高压柜',
        id: 0,
        components: [{
          displayName: "G01高压柜",
          iconResourceId: 0,
          measureId: 1001
        }, {
          displayName: "G02高压柜",
          iconResourceId: 0,
          measureId: 1002
        }]
      }, {
        displayName: '低压柜',
        id: 1,
        components: [{
          displayName: "D01低压柜",
          iconResourceId: 0,
          measureId: 1003
        }]
      }
      ],
      rowId: 0,
      topData: [
        {
          id: 0, name: "高压室1", type: "炸", creatingTime: "2010", displayName: "少", operation: 0
        },
        {
          id: 1, name: "高压室2", type: "炸", creatingTime: "2010", displayName: "少", operation: 0
        },
        {
          id: 2, name: "高压室3", type: "炸", creatingTime: "2010", displayName: "少", operation: 0
        },
        {
          id: 3, name: "高压室4", type: "炸", creatingTime: "2010", displayName: "少", operation: 0
        }
      ],
      //右边固定列
      temperature: "35",//温度
      humidity: "75",//湿度
      waterLevel: "3",//水位
      O3: "0.03",//O3
      SF6: "700",//SF6
      O2: "--",//O2
      AirConditioning: 0,//空凋
      entranceGuard: 0,//门禁
      noise: '--',//噪声
      fan: 0,//风机
      camera: 0,//摄像头
      smoke: 0,//烟感
      infrared: 2,//红外
      ratControlDevice: 0,//驱鼠器
      shutters: 0,//百叶窗
      lighting: 0,//照明
      seen: false,//显示悬浮表格
      form: {
        name: "名称",//名称
        producers: "广州力田科技",//生产产商
        installation: "广州力田科技",//安装地点
        ele: "50",//电流
        voltage: "50",//电压
        power: "96",//总功率因数
        temperature: "正常",//温度
        state: "正常",//状态
      }
    };
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate () { },
  // 实例已经创建完成之后被调用。
  created () {
    vm = this
    vm.getData()
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () { },
  // keep-alive组件激活时调用
  activated () { },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated () { },
  //当前路由改变
  beforeRouteUpdate () { },
  // Vue 实例销毁后调用
  destroyed () { },
  // 计算属性
  computed: {},
  // 数据监听
  watch: {},
  // 方法定义
  methods: {
    //获取组件内容
    getData () {
      let vm = this
      api.customUrl
        .getFrontEndPageCustomParam(0, "/system/monitoringHome", null)
        .then(res => {
          let list = JSON.parse(res.data[0].value)
          let temp = list.find(item => {
            return item.rowId == vm.rowId
          })
          if (temp) {
            vm.list = temp.value
            console.log(vm.list)
            vm.matchData(JSON.parse(JSON.stringify(vm.list)))
          }
        });
    },
    //匹配数据  resData//组数据
    matchData (resData) {
      console.log(resData)
      let a = "枪式摄像头"
      let b = a.indexOf("摄像头")
      console.log(b)
      let AirConditioning = 0//空凋
      let entranceGuard = 0//门禁
      let camera = 0 //摄像头
      let fan = 0//风机
      let smoke = 0//烟感
      let infrared = 0//红外
      let ratControlDevice = 0//驱鼠器
      let shutters = 0//百叶窗
      let lighting = 0//照明
      resData.forEach((item) => {
        if (item.measureName.indexOf("空凋") > -1) {
          AirConditioning += 1
        }
        if (item.measureName.indexOf("门禁") > -1) {
          entranceGuard += 1
        }
        if (item.measureName.indexOf("摄像头") > -1) {
          camera += 1
        }
        if (item.measureName.indexOf("风机") > -1) {
          fan += 1
        }
        if (item.measureName.indexOf("烟感") > -1) {
          smoke += 1
        }
        if (item.measureName.indexOf("红外") > -1) {
          infrared += 1
        }
        if (item.measureName.indexOf("驱鼠器") > -1) {
          ratControlDevice += 1
        }
        if (item.measureName.indexOf("百叶窗") > -1) {
          shutters += 1
        }
        if (item.measureName.indexOf("照明") > -1) {
          lighting += 1
        }
      })
      vm.AirConditioning = AirConditioning
      vm.entranceGuard = entranceGuard
      vm.camera = camera
      vm.fan = fan
      vm.smoke = smoke
      vm.infrared = infrared
      vm.ratControlDevice = ratControlDevice
      vm.shutters = shutters
      vm.lighting = lighting
    },
    leave () {
      vm.imgIndex = null;
      // vm.seen=false
    },
    enter (e, index, row) {
      // vm.seen=true
      vm.imgIndex = index;
      // vm.form.measureName=row.measureName
      // let canvasDom = vm.$refs.canvas;
      // vm.seenPositon.x= vm.list[index].x + vm.list[index].width + canvasDom.offsetLeft
      // vm.seenPositon.y= vm.list[index].y + canvasDom.offsetTop
    },
    handleScroll (e) {
      var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      if (vm.scale >= 0.1 && vm.scale <= 0.2 && delta < 0) {
        return false;
      }
      if (vm.scale <= 3 && vm.scale >= 2.9 && delta > 0) {
        return false;
      }
      vm.scale += delta / 10;
      console.log(delta);
      return false;
    },
    move (e) {
      // let vm = this;
      let odiv = e.target; //获取目标元素
      let disX = null;
      let disY = null;
      let end = false;
      document.onmousemove = e => {
        //鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        if (end) {
          return;
        }
        if (disX == null || disY == null) {
          disX = e.clientX;
          disY = e.clientY;
        } else {
          let left = e.clientX - disX;
          let top = e.clientY - disY;
          disX = e.clientX;
          disY = e.clientY;

          vm.top += top;
          vm.left += left;
        }
      };
      document.onmouseup = e => {
        // document.onmousemove = null;
        // document.onmouseup = null;
        end = true;
      };
    },
    dragResizeClicked (item) {
      let index = vm.list.findIndex((obj) => {
        // return obj.measureName==item.displayName
        return obj.measureId == item.measureId
      })
      if (index > -1) {
        vm.imgIndex = index
      }
    },
    //点击配电房
    changeType (item) {
      console.log(item)
      vm.rowId = item.id
      vm.getData()
    },
    getDig (row) {
      vm.winalarm = true
      console.log(row.typeId)
      console.log(isUndefined(row.typeId))
    }
  }
};
</script>
<style lang="scss" scoped>
.threeD-wrap {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
}
.graph-source {
  width: 260px;
  height: 100%;
  background: #ffffff;
  color: #000000;
  margin-right: 20px;
  .collapse-warp {
    .components-warp-content {
      .com-item {
        cursor: pointer;
      }
    }
  }
}
.box-top {
  height: 7%;
  background: #fff;
  color: #fff;
  font-size: 15px;
  display: flex;
  flex-flow: row;
  align-items: center;
  overflow: auto;
  .litle {
    background: rgba(22, 155, 213);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    margin: 0 2px;
    cursor: pointer;
    padding: 5px 10px;
    box-sizing: border-box;
  }
}
.box-index {
  position: absolute;
  z-index: 1000;
  right: 28px;
  left: 1145px;
  top: 68px;
  bottom: 28px;
  background: rgba(23, 32, 64);
  display: flex;
  flex-flow: column;
  color: #fff;
  .horn {
    position: absolute;
    width: 20px;
    height: 20px;
    z-index: 1199;
  }
  .horn1 {
    border-top: 3px solid;
    border-left: 3px solid;
    border-color: rgba(97, 244, 254);
    top: -3px;
    left: -3px;
  }
  .horn2 {
    border-top: 3px solid;
    border-right: 3px solid;
    border-color: rgba(97, 244, 254);
    top: -3px;
    right: -3px;
  }
  .horn3 {
    border-bottom: 3px solid;
    border-left: 3px solid;
    border-color: rgba(97, 244, 254);
    bottom: -3px;
    left: -3px;
  }
  .horn4 {
    border-bottom: 3px solid;
    border-right: 3px solid;
    border-color: rgba(97, 244, 254);
    bottom: -3px;
    right: -3px;
  }
  .title {
    margin: 5px auto;
    .title-box {
      padding: 3px;
      display: inline-block;
      border: 1px solid;
      border-color: #61f4fe;
      box-sizing: border-box;
    }
    .title-box-left {
      border-radius: 4px 0px 0px 4px;
    }
    .title-box-right {
      border-radius: 0px 4px 4px 0px;
    }
    .bgcolor {
      background: rgba(0, 121, 254);
    }
  }
  .centent {
    display: flex;
    flex: 1;
    flex-flow: column;
    margin: 5px 3px;
    .row {
      display: flex;
      flex: 1;
      flex-flow: row;
      .left {
        display: flex;
        flex: 1;
        flex-flow: row;
        border: 1px solid rgba(46, 133, 223);
        border-bottom: 0;
        justify-content: center;
        align-items: center;
        .img {
          display: flex;
          flex: 1;
          flex-flow: column;
          .imgvalue {
            font-size: 23px;
            font-weight: 600;
            .valuedw {
              font-size: 12px;
              font-weight: normal;
            }
          }
          .iconsize {
            font-size: 29px;
          }
          .ziti {
            font-size: 12px;
            color: rgba(1, 146, 244);
            margin-top: 4px;
          }
        }
        .valuebg {
          color: rgba(153, 153, 153);
        }
        .value {
          display: flex;
          flex: 1;
          flex-flow: column;
          font-size: 22px;
          font-weight: 600;
          height: 100%;
          justify-content: center;
          .valuedw {
            font-size: 12px;
            font-weight: normal;
          }
          .value-icon {
            display: flex;
            flex: 1;
            justify-content: center;
            align-items: center;
          }
          .value-ziti {
            text-align: right;
            color: rgba(244, 234, 42);
          }
        }
        .valuegreen {
          color: rgba(2, 144, 6);
        }
        .valuered {
          color: rgba(219, 6, 13);
        }
      }
      .bottom {
        border-bottom: 1px solid rgba(46, 133, 223);
      }
    }
  }
}
.canvas {
  width: 100%;
  height: 93%;
  background: #ffffff;
  overflow: hidden;
}
.graph-source-param {
  width: 260px;
  height: 100%;
  color: #000000;
  background: #ffffff;
  .param-item {
    display: flex;
    align-items: center;
    padding: 4px 6px;
    .title {
      flex: 0 0 60px;
      text-align: right;
    }
  }
}
.showform {
  position: absolute;
  // left: 80px;
  // top: 20px;
  width: 240px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ccc;
  z-index: 1000;
  color: #1e1e1e;
  height: 290px;
  display: flex;
  flex-flow: column;
  -webkit-transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
  .top {
    padding: 5px;
    text-align: left;
    background: rgba(98, 99, 101);
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    box-sizing: border-box;
  }
  .centent {
    display: flex;
    flex: 1;
    flex-flow: column;
    .row {
      display: flex;
      flex: 1;
      flex: row;
      align-items: center;
      flex-flow: row;
      .left {
        flex: 1;
        border: 1px solid;
        border-left: 0;
        padding: 2px;
        box-sizing: border-box;
        border-color: gainsboro;
        border-top: 0;
        line-height: 24px;
      }
      .right {
        flex: 1;
        border: 1px solid gainsboro;
        box-sizing: border-box;
        border-right: 0;
        border-top: 0;
        padding: 2px;
        box-sizing: border-box;
        border-left: 0;
        line-height: 24px;
      }
    }
  }
}

.float-box {
  position: absolute;
  top: calc(50% - 250px);
  right: 40px;
  border-radius: 10px;
  width: 200px;
  background: #ffffff;
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  box-shadow: 0px 0px 10px 5px rgba(165, 165, 165, 0.9);
  overflow: hidden;
  z-index: 1000;
}
.float-box-item {
  width: 50%;
  color: #000;
  display: flex;
  flex-flow: column;
  padding: 5px;
  box-sizing: border-box;
  .top {
    align-items: center;
    display: flex;
    justify-content: center;
    font-size: 16px;
  }
}
.float-box-item i {
  font-size: 30px;
  margin-right: 5px;
}
.float-box-item div {
  padding-top: 4px;
}
.float-box-item .num {
  font-size: 20px;
  color: rgba(1, 145, 243);
  padding: 0px 10px;
}
</style>
<style lang="scss">
.threeD-wrap {
  .vdr.active:before {
    outline: none !important;
  }
}
</style>